import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PairChallenge } from '@era/locations-sdk';

@Component({
  selector: 'era-pairing-challenge-ui',
  templateUrl: './pairing-challenge.component.html',
  styleUrls: ['./pairing-challenge.component.scss'],
})
export class PairingChallengeComponent {
  @Input() challenge: PairChallenge;
  @Output() readonly enroll = new EventEmitter<PairChallenge>();

  public continue() {
    this.enroll.emit(this.challenge);
  }
}
